export const Brand = ({ light }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-logo">
    <div className="relative h-9 w-9 rounded-md bg-[var(--blue)] overflow-hidden">
      <div className="absolute inset-x-0 bottom-0 h-3 bg-[var(--red)]" />
      <div className="absolute inset-x-0 bottom-3 h-1 bg-white" />
      <span className="absolute inset-0 grid place-items-center pb-2 font-display font-extrabold text-white text-lg">M</span>
    </div>
    <div className={`font-display leading-tight ${light ? "text-white" : "text-[var(--navy)]"}`}>
      <div className="font-extrabold text-lg tracking-tight">Maderian</div>
      <div className="text-[10px] uppercase tracking-[0.25em] opacity-80 -mt-0.5">Us Serve</div>
    </div>
  </div>
);

export const SimNotice = ({ className = "" }) => (
  <p className={`text-xs text-slate-500 ${className}`} data-testid="simulation-notice">
    Maderian Us Serve is a simulated investing-learning environment. Balances are virtual bank with care learning process transfers.
  </p>
);
